import { render, staticRenderFns } from "./productupdate.vue?vue&type=template&id=57455614&scoped=true&"
import script from "./productupdate.vue?vue&type=script&lang=js&"
export * from "./productupdate.vue?vue&type=script&lang=js&"
import style0 from "./productupdate.vue?vue&type=style&index=0&id=57455614&prod&lang=scss&"
import style1 from "./productupdate.vue?vue&type=style&index=1&id=57455614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57455614",
  null
  
)

export default component.exports